<template>
	<div v-loading="loading" style="position: relative;flex: 1;height: 100%;overflow: hidden;">
		<div style="width: 100%;height: 100%;padding: 15px;overflow-x: hidden;overflow-y: auto;">
			<!-- 顶部查询 -->
			<div style="border: 1px solid #ccc;background: #f7f7f7;border-radius: 5px;">
				<div class="base_inquire" style="padding: 20px 30px 5px;">
					<div class="b_item">
						<span class="b_label">开始日期：</span>
						<el-date-picker
							v-model="search_startDate"
							:editable="false"
							:clearable="false"
							placeholder="开始日期"
							type="date"
							value-format="yyyy-MM-dd"
							@change="handleSearchStartDateChange"
						>
						</el-date-picker>
					</div>
					
					<div class="b_item">
						<span class="b_label">结束日期：</span>
						<el-date-picker
							v-model="search_endDate"
							:editable="false"
							:clearable="false"
							placeholder="结束日期"
							type="date"
							value-format="yyyy-MM-dd"
							@change="handleSearchEndDateChange"
						>
						</el-date-picker>
					</div>
					
					<div class="b_item">
						<span class="b_label">带训人：</span>
						<el-input v-model="search_trainer" class="b_inp" placeholder="带训人"></el-input>
					</div>
					
					<div class="b_item">
						<span class="b_label">患者姓名：</span>
						<el-input v-model="search_name" class="b_inp" placeholder="患者姓名"></el-input>
					</div>
					
					<div class="b_item">
						<span class="b_label">所属机构：</span>
						<el-input v-model="search_firmName" class="b_inp" placeholder="所属机构"></el-input>
					</div>

					<el-button type="primary" @click="handleSearchClick">查询</el-button>
				</div>
			</div>
			<!-- 顶部查询 end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="firmName"
						label="机构名称"
					>
					</el-table-column>
					<el-table-column
						prop="createDate"
						label="创建日期"
					>
					</el-table-column>
					<el-table-column
						prop="name"
						label="患者姓名"
					>
					</el-table-column>
					<el-table-column
						prop="trainer"
						label="带训人"
					>
					</el-table-column>
					<el-table-column
						prop="trainingContent"
						label="软件训练内容"
					>
					</el-table-column>
					<el-table-column
						prop="trainingEffect"
						label="软件训练评价"
					>
					</el-table-column>
					<el-table-column
						prop="smallInstruments"
						label="小器械训练项目"
					>
					</el-table-column>
					<el-table-column
						prop="smallInstrumentsEffect"
						label="小器械训练评价"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
	</div>
</template>

<script>
	import Api from '../../../../api/index.js';
	import BaseMethods from '../../../../assets/js/base.js';
	import { mapState } from 'vuex';
	
	export default {
		mounted() {
			this.materials = [];
			this.getMaterials();
		},
		data() {
			return {
				loading: false,

				search_startDate: `${ new Date().getFullYear() }-${ new Date().getMonth() + 1 >= 10 ? (new Date().getMonth() + 1) : ('0' + (new Date().getMonth() + 1)) }-01`,
				search_endDate: BaseMethods.getTime(new Date().getTime()),
				search_trainer: '',
				search_name: '',
				search_firmName: '',
				
				currentPage: 1,
				total: 0,
				tableData: []
			}
		},
		computed: {
			...mapState([
				'authInfo'
			])
		},
		methods: {
			/******************** @Events *************************/
			// 切换查询时间
			handleSearchStartDateChange() {
				this.compareSearchDate();
			},
			// 切换查询时间
			handleSearchEndDateChange() {
				this.compareSearchDate();
			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.search();
				}
			},
			// 点击查询
			handleSearchClick() {
				this.search();
			},
			
			/******************** @Function *************************/
			// 获取小器械
			getMaterials() {
				const that = this;
				that.loading = true;
				Api.getMaterials().then((res) => {
					if (res.data.success) {
						res.data.data && res.data.data.forEach(v => {
							that.materials.push({
								id: v.titleNameId,
								name: v.titleName,
								example: v.example
							});
						});
						that.search();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 查询
			search() {
				const that = this;
				that.loading = true;
				var requestData = { 
					"category": that.authInfo.ucategory,
					"endTime": that.search_endDate,
					"guideDoctorName": that.search_trainer,
					"limit": 10,
					"loginerEnterpriseId": that.authInfo.uenterpriseId,
					"loginerId": that.authInfo.uid,
					"pageNum": that.currentPage,
					"startTime": that.search_startDate,
					"type": null,
					"uenterpriseName": that.search_firmName,
					"userName": that.search_name
				};
				Api.findDataByTrainer(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						let data = [];
						that.total = res.data.data.totalItems;
						res.data.data.data.forEach((v) => {
							let materials = v.smallInstruments ? v.smallInstruments.split(',') : [];
							let material_names = [];
							materials.forEach(v1 => {
								that.materials.forEach(v2 => {
									v1 == v2.id && (material_names.push(v2.name));
								});
							});
							data.push({
								firmName: v.uenterpriseName || '',
								createDate: v.createTime ? v.createTime.split(' ')[0] : '',
								name: v.userName || '',
								trainer: v.guideDoctorName || '',
								trainingContent: v.trainingContent || '',
								trainingEffect: v.trainingEffect || '',
								smallInstruments: material_names.join(','),
								smallInstrumentsEffect: v.smallInstrumentsEffect || ''
							});
						});
						that.tableData = data;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 比较开始时间和结束时间
			compareSearchDate() {
				var startDate = new Date(this.search_startDate).getTime(),
					endDate = new Date(this.search_endDate).getTime();
				if (endDate < startDate) {
					this.search_startDate = this.search_endDate;
					this.$message({
						message: '结束时间不能小于开始时间',
						type: 'warning'
					});
				}
			}
		}
	}
</script>

<style scoped>
</style>
